import script from "./KAM001-v2.vue?vue&type=script&setup=true&lang=ts"
export * from "./KAM001-v2.vue?vue&type=script&setup=true&lang=ts"

import "./KAM001-v2.vue?vue&type=style&index=0&id=2d3d3601&scoped=true&lang=css"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3d3601"]])

export default __exports__